export default __webpack_public_path__ + "static/media/blue_pawn.a7350f93.png";